import { Income } from '../models/income';
import { PagedStoreBase } from './PagedStoreBase';

export default class IncomeStore extends PagedStoreBase<Income> {
  constructor() {
    super('Incomes');
  }

  protected sortItems = (items: Income[]) => {
    return items.sort(({ incomeDate: ad }, { incomeDate: bd }) => {
      const a = ad.getTime();
      const b = bd.getTime();
      return b > a ? 1 : b < a ? -1 : 0;
    });
  };

  setItem = (item: Income) => {
    item.incomeDate = new Date(item.incomeDate);
    this.itemRegistry.set(item.id, item);
  };
}
